import Immutable from "immutable";
import RecordClassCreator from "services/record";
import {
  AnalyticsListItemValue
} from "./helpers";

interface AnalyticsListItemAttributes {
  dataType: string;
  valueType: string;
  value?: unknown;
  meta?: Immutable.Map<string, unknown>;
  values: Immutable.List<AnalyticsListItemValue>;
}

export default class AnalyticsListItem extends RecordClassCreator<AnalyticsListItemAttributes>({
  type: "analyticsListItem",
  dataType: null,
  value: null,
  valueType: "number",
  meta: Immutable.Map(),
  values: Immutable.List()
}) {}
